(function ($, window) {
    $(function () {
        // Sticky filters
        $(".c-site-header").stick_in_parent({
            offset_top: -1
        });
    });
})(jQuery, window);